export default __webpack_public_path__ + "static/media/old-mustang.87854d2e.svg";